import { CountryModel } from 'src/app/shared/models/CountryModel';

export class PersonalDetailsReqRes {
  public firstName: string;
  public lastName: string;
  public phone1: string;
  public countryId: number;
  public stateName: string;
  public country: CountryModel;
  public email: string;
}
